import { ItnlIntegrationScript } from "@/data/types/ItnlIntegrationScript";
import { categoryIntroShowMoreScripts, klarnaRefreshExpressButton, klarnaRefreshPlacement, showMoreLessDescriptionScript } from "./itnlIntegrationScriptsScripts";
import { Settings } from "@/data/Settings";

export const getPageLoadScripts = (
    {
        ifKlarnaexists,
        settings,
        pageType
    }:
        {
            ifKlarnaexists: boolean
            settings: Settings,
            pageType?:string
        }
) => {
    let scripts: ItnlIntegrationScript[] = [
        {
            scriptContent:`
                document.body.classList = '';
                document.body.classList.add('${pageType}');
            `,
            id:'add_pageType_as_class_to_body_element'
        },
        { scriptContent: categoryIntroShowMoreScripts(), id: "category_intro_show_hide_script" },
        { scriptContent: showMoreLessDescriptionScript(), id: "show_more_less_description_script", delay: 2000 },
        { url: "https://integrations.etrusted.com/applications/widget.js/v2" , id:"etrusted_widget_script" , retainScript:true, skipIfExists:true}
    ];
    if (ifKlarnaexists) {
        scripts.push(
            {
                url: settings.userData.Klarna_ExpressButtonEndPointURL,
                attrs: [['data-id', process.env.NEXT_PUBLIC_KLARNA_MERCHANT_ID ?? ''],
                ['data-environment', settings.userData.Klarna_Environment]],
                id: 'klarna_express_button',
                onLoadScripts: [
                    {
                        id: "page_klarna_refresh_button",
                        scriptContent: klarnaRefreshExpressButton()
                    }
                ],
                retainScript: true,
                skipIfExists: true
            },
            {
                url: settings.userData.Klarna_OnsiteMessagingEndPointURL,
                attrs: [['data-client-id', process.env.NEXT_PUBLIC_KLARNA_ONSITEMESSAGING_CLIENTID ?? '']],
                id: 'klarna_onsite_messaging',
                onLoadScripts: [
                    {
                        id: "klarna_onsitemessaging",
                        scriptContent: klarnaRefreshPlacement()
                    }
                ],
                retainScript: true,
                skipIfExists: true
            }
        );
    }
    return scripts;
}